import Marquee from "react-fast-marquee";

const ITEMS = ["Le Boulou", "N1 Femme", "N3 Homme", "École de vélo", "Loisir", "Esprit d'équipe", "Formation"];

export default function EditorialMarquee({ dark = true }) {
  return (
    <div
      data-testid="editorial-marquee"
      className={`py-6 sm:py-8 overflow-hidden border-y ${dark ? "bg-navy border-white/10" : "bg-white border-navy/10"}`}
    >
      <Marquee speed={35} gradient={false} pauseOnHover>
        {[...ITEMS, ...ITEMS].map((item, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span
              className={`font-heading uppercase font-semibold tracking-tight text-4xl sm:text-6xl px-6 sm:px-10 ${
                dark ? "text-outline-white" : "text-outline-navy"
              }`}
            >
              {item}
            </span>
            <span className="h-3 w-3 bg-rouge rotate-45 shrink-0" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
